module.exports = {"slides":[{"children":[{"element":"Heading","children":"RealTime with WebSockets"},{"element":"Paragraph","children":"TODO: Presentation to be migrated"}]}]}


//////////////////
// WEBPACK FOOTER
// ./pages/talks/realtime-websockets/realtime-websockets.json
// module id = ./pages/talks/realtime-websockets/realtime-websockets.json
// module chunks = 8